import React, { ReactElement, useEffect, useRef, useState } from 'react'
import InputRange from '../../../InputRange'
import useOutsideClick from '../../../../hooks/useOutsideClick'


const ToolbarToolRange = (props) => {
    const [value, setValue] = useState([50])
    const [barVisibility, setBarVisibility] = useState(false)
    const myRef = useRef()

    useOutsideClick(myRef, () => {
        setBarVisibility(false)
    })

    useEffect(() => {
        props.onChange(value)
    }, [value])

    return (
        <>
            <div ref={myRef} className={'toolbarTool'}>
                <div onClick={() => setBarVisibility(!barVisibility)} className='icon'>
                    <img src={props.icon}/>
                </div>

                {barVisibility && (
                    <div className={'progressBar'}>
                        <InputRange values={value} onChange={setValue}/>
                    </div>
                )}
            </div>
            <style jsx="true">
                {`
                  .progressBar {
                    position: absolute;
                    height: 35px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 286px;
                    padding: 0 10px;
                    background: rgba(244, 247, 254, 1);
                    border-radius: 10px;
                    z-index: 1;
                    top: 106%;
                  }

                  .toolbarTool {
                    position: relative;
                    height: max-content;
                    width: max-content;
                  }

                  .icon {
                    cursor: pointer;
                    width: max-content;
                  }
                `}
            </style>
        </>
    )
}

export default ToolbarToolRange
